export default __webpack_public_path__ + "static/media/tv-desk.3ee3b72e.png";